import { Link } from "react-router-dom";
import type { CatalogBrandSummary } from "@/lib/api-client";

export interface BrandsStripProps {
  brands: CatalogBrandSummary[];
}

/**
 * Porté à l'identique depuis apps/web/components/home/BrandsStrip.tsx. Seul
 * changement : `next/link` → `Link` de react-router-dom.
 */
export function BrandsStrip({ brands }: BrandsStripProps) {
  const featured = brands.filter((brand) => brand.isFeatured);
  if (featured.length === 0) return null;

  return (
    <section className="border-y border-line bg-cream2/60 py-8 lg:py-10">
      <div className="container-vvs">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span aria-hidden="true" className="inline-block h-7 w-1 rounded-sm bg-gold" />
            <h2 className="font-display text-xl font-semibold text-navy lg:text-2xl">Marques à la une</h2>
          </div>
          <Link to="/marques" className="font-body text-sm font-medium text-golddark hover:text-gold2">
            Toutes les marques →
          </Link>
        </div>

        <ul className="mt-4 flex flex-wrap gap-3">
          {featured.map((brand) => (
            <li key={brand.id}>
              <Link
                to={`/marques/${brand.slug}`}
                className="inline-flex items-center gap-2.5 rounded-sm border border-line bg-white py-2 pl-2 pr-4 font-body text-sm font-medium text-navy transition-colors hover:border-gold hover:text-golddark"
              >
                {brand.logoUrl ? (
                  <img src={brand.logoUrl} alt="" loading="lazy" className="h-8 w-8 rounded-full object-cover" />
                ) : (
                  <span
                    aria-hidden="true"
                    className="flex h-8 w-8 items-center justify-center rounded-full bg-navy font-display text-xs font-semibold text-cream"
                  >
                    {brand.name.charAt(0)}
                  </span>
                )}
                {brand.name}
                {brand.countryOfOrigin ? (
                  <span className="text-xs text-muted">({brand.countryOfOrigin})</span>
                ) : null}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
